import React, { useEffect } from "react";
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    TextField, Select, MenuItem, Button, Switch,
    FormControlLabel, Stack
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { useSnackbar } from '../contexts/SnackbarProvider';
import axiosInstance from "../utils/axiosInstance";

const DeviceModal = ({ open, onClose, defaultValues, warehouses, onSuccess }) => {
    const { showSnackbar } = useSnackbar();

    const { handleSubmit, control, reset } = useForm({
        defaultValues
    });

    // open が変わるタイミングでフォームを reset
    useEffect(() => {
        if (open) reset(defaultValues);
    }, [open, defaultValues, reset]);

    const onSubmit = async (data) => {
        try {
            const payload = {
                ...data,
                warehouse_id: data.warehouse_id ? Number(data.warehouse_id) : null,
                is_active: Boolean(data.is_active)
            };

            if (defaultValues?.device_id) {
                await axiosInstance.put(`/picking/devices/${defaultValues.device_id}`, payload);
                showSnackbar("端末を更新しました", "success");
            } else {
                await axiosInstance.post('/picking/devices', payload);
                showSnackbar("端末を追加しました", "success");
            }

            onClose();
            onSuccess?.();
        } catch (err) {
            console.error(err);
            showSnackbar(err?.response?.data?.message || '保存に失敗しました', 'error');
        }
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>{defaultValues?.device_id ? "端末編集" : "端末追加"}</DialogTitle>
            <DialogContent>
                <Stack spacing={2} mt={1}>
                    <Controller
                        name="device_name"
                        control={control}
                        rules={{
                            required: "端末名は必須です",
                            maxLength: { value: 100, message: "端末名は100文字以内で入力してください" }
                        }}
                        render={({ field, fieldState }) => (
                            <TextField
                                {...field}
                                label="端末名"
                                required
                                error={!!fieldState.error}
                                helperText={fieldState.error?.message}
                                inputProps={{ maxLength: 100 }}
                            />
                        )}
                    />
                    <Controller
                        name="warehouse_id"
                        control={control}
                        render={({ field }) => (
                            <Select {...field} displayEmpty>
                                <MenuItem value="">倉庫を選択してください</MenuItem>
                                {warehouses.map(w => (
                                    <MenuItem key={w.warehouse_id} value={w.warehouse_id}>
                                        {w.warehouse_name}
                                    </MenuItem>
                                ))}
                            </Select>
                        )}
                    />
                    <Controller
                        name="is_active"
                        control={control}
                        render={({ field }) => (
                            <FormControlLabel
                                control={<Switch checked={field.value} onChange={e => field.onChange(e.target.checked)} />}
                                label="有効"
                            />
                        )}
                    />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>キャンセル</Button>
                <Button variant="contained" onClick={handleSubmit(onSubmit)}>
                    {defaultValues?.device_id ? "更新" : "追加"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeviceModal;